import gql from "graphql-tag";

export default gql`
  mutation deleteContract($customerId: ID, $contractId: ID) {
    deleteContract(customerId: $customerId, contractId: $contractId) {
      id
    }
  }
`;
